import React, {ReactElement} from 'react';
import {Property as CSSProperty} from 'csstype';

export interface CircleStyles {
  top?: CSSProperty.Top;
  right?: CSSProperty.Right;
  bottom?: CSSProperty.Bottom;
  left?: CSSProperty.Left;
  width?: CSSProperty.Width;
  height?: CSSProperty.Height;
  marginBottom?: CSSProperty.MarginBottom;
  marginLeft?: CSSProperty.MarginLeft;
  marginRight?: CSSProperty.MarginRight;
  marginTop?: CSSProperty.MarginTop;
  transform?: CSSProperty.Transform;
  transition?: CSSProperty.Transition;
  zIndex?: CSSProperty.ZIndex;
  opacity?: CSSProperty.Opacity;
}

export interface Props {
  style: CircleStyles;
  imgUrl?: string;
  isSolid?: boolean;
  className?: string;
}

const SolidCircle = ({style, imgUrl, className}: Props): ReactElement => (
  <svg viewBox="0 0 100 100" style={style} className={className}>
    {imgUrl ? (
      <>
        <defs>
          <clipPath id="circle">
            <circle cx="50" cy="50" r="50" fill="currentColor" />
          </clipPath>
        </defs>
        {/* eslint-disable-next-line */}
        <image href={imgUrl} width="100" height="100" clipPath="url(#circle)" />
      </>
    ) : (
      <circle cx="50" cy="50" r="50" fill="currentColor" />
    )}
  </svg>
);

const Doughnut = ({style, className}: Props): ReactElement => (
  <svg viewBox="0 0 100 100" style={style} className={className}>
    <circle cx="50" cy="50" r="37" fill="transparent" stroke="currentColor" strokeWidth="23" />)
  </svg>
);

const Circle = ({style, imgUrl, isSolid, className}: Props): ReactElement =>
  isSolid ? (
    <SolidCircle style={style} imgUrl={imgUrl} className={className} />
  ) : (
    <Doughnut style={style} className={className} />
  );

export default Circle;
